﻿<template>
    <div>
        <div class="row" v-if="canWrite">
            <div class="col-6 mx-auto">
                <bootstrap-box class="text-center">
                    <template v-slot:body>
                        <router-link to="/Newsroom/Create" class="btn btn-primary">
                            {{resource('Newsroom_Index_NewItem_Btn')}}
                        </router-link>
                    </template>
                </bootstrap-box>
            </div>
        </div>
        
        <remote-newsroom-item-list>
            <template v-slot:default="{newsroomItems}">
                <newsroom-item-display
                    v-for="newsroomItem in newsroomItems"
                    :key="newsroomItem.id"
                    :title="newsroomItem.title"
                    :content="newsroomItem.content"
                    :date="newsroomItem.date"
                    :id="newsroomItem.id"
                />
            </template>
        </remote-newsroom-item-list>
    </div>
</template>

<script>
    import permissionsMixin from '../Mixins/permissions';
    import resourceMixin from "../../../Util/Mixins/resources";
    
    import BootstrapBox from "../../../Components/Util/BootstrapBox.vue";
    import RemoteNewsroomItemList from "./Remote/RemoteNewsroomItemList.vue";
    import NewsroomItemDisplay from "./NewsroomItemDisplay.vue";

    export default {
        name: 'newsroom-index',
        components: {
            BootstrapBox,
            RemoteNewsroomItemList,
            NewsroomItemDisplay
        },
        mixins: [resourceMixin, permissionsMixin]
    }
</script>